export default "__VITE_ASSET__DcRnLvDH__"